export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f346812d71c93911916e8cd9e9e6bf6aaa7e511ae&name=fetchTypeahead!'